var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "main-link-card h-100",
    attrs: {
      "to": _vm.to,
      "elevation": "0",
      "tile": ""
    }
  }, [_c('h4', {
    staticClass: "tit tit--xs mb-14px mb-lg-36px"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _c('p', {
    staticClass: "txt grey--text text--lighten-3 line-height-15 break-keep"
  }, [_vm._t("default")], 2), _c('v-img', {
    attrs: {
      "src": _vm.icon,
      "contain": "",
      "max-width": "200",
      "alt": ""
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }